<template>
  <span>
    <!-- Undefined status -->
    <template v-if="Accomplished == null">
      <b-icon-circle-fill 
        style="color: lightgray;" 
        :font-scale="iconScale"
        :title="TooltipTitle"
        v-b-tooltip.hover.nofade="toolTipDelay"
      />
    </template>

    <!-- Healing -->
    <template v-if="HealingStatus == 'in_progress' && Accomplished != null">
      <b-icon
        v-if="Accomplished"
        icon="check-circle-fill"
        :style="{ color: successColor}"
        :font-scale="iconScale"
        :title="TooltipTitle"
        v-b-tooltip.hover.nofade="toolTipDelay"
      ></b-icon>
      <b-iconstack
        v-if="!Accomplished && IsCurrentWave"
        :font-scale="iconScale"
      >
        <b-icon 
          stacked 
          icon="circle-fill" 
          :style="{ color: mehColor}"
          :title="$t('Webportal.CX.Margin.HealingInProgress')"
          v-b-tooltip.hover.nofade="toolTipDelay"
        ></b-icon>
        <b-icon stacked icon="wrench" scale="0.6" variant="white"></b-icon>
      </b-iconstack>
      <b-icon
        v-if="!Accomplished && !IsCurrentWave"
        icon="x-circle-fill"
        :style="{ color: frownColor}"
        :font-scale="iconScale"
        :title="TooltipTitle"
        v-b-tooltip.hover.nofade="toolTipDelay"
      ></b-icon>
    </template>

    <!-- Not currently healing -->
    <template v-if="HealingStatus != 'in_progress' && Accomplished != null">
      <template v-if="InHealingPeriod && IsCurrentWave && !IsHealingDeactivated && HealingStatus != 'finished' && AvailableHealings > 0 && WaveResult < Threshold">
        <b-icon
          v-if="Accomplished"
          icon="check-circle-fill"
          :style="{ color: successColor}"
          :font-scale="iconScale"
          :title="TooltipTitle"
          v-b-tooltip.hover.nofade="toolTipDelay"
        ></b-icon>
        <b-icon
          v-if="!Accomplished"
          icon="exclamation-circle-fill"
          :font-scale="iconScale"
          :style="{ color: mehColor}"
          animation="throb"
          :title="$t('Webportal.CX.Margin.HealingPossible')"
          v-b-tooltip.hover.nofade="toolTipDelay"
        ></b-icon>
      </template>

      <template v-else>
        <b-icon v-if="Accomplished"
                icon="check-circle-fill"
                :style="{ color: successColor}"
                :font-scale="iconScale"
                :title="TooltipTitle"
                v-b-tooltip.hover.nofade="toolTipDelay" />
        <b-icon
          v-if="!Accomplished"
          icon="x-circle-fill"
          :style="{ color: frownColor}"
          :font-scale="iconScale"
          :title="TooltipTitle"
          v-b-tooltip.hover.nofade="toolTipDelay"
        ></b-icon>
      </template>
    </template>

    <!-- Not yet implemented -->
    <template v-if="false">
      <b-iconstack :font-scale="iconScale">
        <b-icon stacked icon="circle-fill" variant="success" :style="{ color: successColor}"></b-icon>
        <b-icon stacked icon="check" variant="white"></b-icon>
        <b-icon stacked icon="circle" :style="{ color: mehColor}"></b-icon>
      </b-iconstack>

      <b-iconstack :font-scale="iconScale">
        <b-icon stacked icon="circle-fill" :style="{ color: frownColor}"></b-icon>
        <b-icon stacked icon="x" scale="0.9" variant="white"></b-icon>
        <b-icon stacked icon="circle" :style="{ color: mehColor}"></b-icon>
      </b-iconstack>
    </template>
  </span>
</template>

<script>
import AppConfig from "@/mixins/AppConfig";
export default {
  name: "MarginKpiStatusIndicator",

  mixins: [AppConfig],

  props: {
    iconScale:            { type: Number, default: 0.9 },
    InHealingPeriod:      { type: Boolean },
    HealingStatus:        { type: String },
    IsCurrentWave:        { type: Boolean },
    IsHealingDeactivated: { type: Boolean },
    AvailableHealings:    { type: Number },
    Accomplished:         { type: Boolean, default: null },
    ColorRange:           { type: Array },
    WaveResult:           { type: Number, default: null },
    TooltipTitle:         { type: String, default: null },
    Threshold:            { type: Number, default: 1 },
  },

  computed: {
    successColor() {
      return this.ColorRange.find(s => s.Smiley == "grin")?.Color;
    },
    mehColor() {
      return this.ColorRange.find(s => s.Smiley == "meh")?.Color;
    },
    frownColor() {
      return this.ColorRange.find(s => s.Smiley == "frown-open")?.Color;
    },
  }
};
</script>
